import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><g opacity=".7" fill="#7F7F7F"><path fillRule="evenodd" clipRule="evenodd" d="M2 3.85a1 1 0 011-1h9a1 1 0 011 1V7h-1V5H3v7h4v1H3a1 1 0 01-1-1V3.85z" /><path d="M4 2h1v2H4zM10 2h1v2h-1zM10 8h1v5h-1z" /><path fillRule="evenodd" clipRule="evenodd" d="M13 10v1H8v-1h5z" /></g></svg>);